import { useState, useEffect } from "react";

export default function Toggle({ id, checked = false, onChange }) {
    const [enabled, setEnabled] = useState(checked);

    useEffect(() => {
        setEnabled(checked);
    }, [checked]);

    const toggle = () => {
        const newState = !enabled;
        setEnabled(newState);
        if (onChange) onChange(newState);
    };

    return (
        <label className="inline-flex relative items-center cursor-pointer">
            <input
                type="checkbox"
                id={id}
                className="sr-only peer"
                checked={enabled}
                readOnly
            />
            <div
                onClick={toggle}
                className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-accent peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent"
            ></div>
        </label>
    );
}